// extracted by mini-css-extract-plugin
export default {"container":"uS2cwa","block":"zGHF83"};